import Vue from 'vue'
import Router from 'vue-router'
import './views/index.vue';
import './views/type.vue';
Vue.use(Router)

export default new Router({
	mode: 'history',
	//mode: 'hash',
	routes: [{
			path: '/',
			component: () => import('./views/index.vue')
		}, {
			path: '/index.(html|htm)',
			component: () => import('./views/index.vue')
		}, {
			path: '/tg.(html|htm)',
			component: () => import('./views/index.vue')
		}, {
			path: '/type/:id(\\d+)\\.(html|htm)',
			component: () => import('./views/type.vue')
		}, {
			path: '/type/:id(\\d+)\\_:page(\\d+)\\.(html|htm)',
			component: () => import('./views/type.vue')
		}, {
			path: '/genre/:id(\\d+)\\_:genre(\\d+)\\.(html|htm)',
			component: () => import('./views/genre.vue')
		}, {
			path: '/genre/:id(\\d+)\\_:genre(\\d+)\\_:page(\\d+)\\.(html|htm)',
			component: () => import('./views/genre.vue')
		}, {
			path: '/video/:video_id(\\d+)\\.(html|htm)',
			component: () => import('./views/video.vue')
		}, {
			path: '/search.(html|htm)',
			component: () => import('./views/search.vue')
		},{
			path: '/melons.(html|htm)',
			component: () => import('./views/melon.vue')
		}, {
			path: '/melons_:genre(\\d+)\\_:page(\\d+)\\.(html|htm)',
			component: () => import('./views/melon.vue')
		}, {
			path: '/melon/:id(\\d+)\\.(html|htm)',
			component: () => import('./views/melon_detail.vue')
		}, {
			path: '/product/yp_:type(\\d+)\\_:grade(\\d+).(html|htm)',
			component: () => import('./views/product_yp.vue')
		}, {
			path: '/product/yp_:type(\\d+)\\_:grade(\\d+)\\_:page(\\d+).htm',
			component: () => import('./views/product_yp.vue')
		}, {
			path: '/product/yp_detail_:id(\\d+).(html|htm)',
			component: () => import('./views/product_yp_detail.vue')
		}, {
			path: '/product/yao.(html|htm)',
			component: () => import('./views/product_yao.vue')
		}, {
			path: '/product/ai.(html|htm)',
			component: () => import('./views/product_ai.vue')
		}, {
			path: '/product/game.(html|htm)',
			component: () => import('./views/product_game.vue')
		}, {
			path: '/novel/index.(html|htm)',
			component: () => import('./views/novel_index.vue')
		}, {
			path: '/novel/type/:type(\\d+)\\.(html|htm)',
			component: () => import('./views/novel_type.vue')
		}, {
			path: '/novel/type/:type(\\d+)\\_:page(\\d+)\\.(html|htm)',
			component: () => import('./views/novel_type.vue')
		}, {
			path: '/novel/read/:id(\\d+)\\.(html|htm)',
			component: () => import('./views/novel_read.vue')
		}, {
			path: '/novel/search.(html|htm)',
			component: () => import('./views/novel_search.vue')
		}, {
			path: '/404',
			component: () => import('./views/404.vue')
		}, {
			path: '*',
			redirect: '/404'
		},
  	]
})
